import React from "react";
import Illustration2 from "../../resources/Illustration-2.svg";
import Check from "../../resources/Check.png";
import "./HomeSectionThree.css";

function HomeSectionThree() {
  return (
    <div className="homeSectionThree">
      <div className="homeSectionThree__one">
        <div className="homeSectionThree__one--illustration">
          <img src={Illustration2} />
        </div>
      </div>

      <div className="homeSectionThree__two">
        <div className="homeSectionThree__two--heading">
          <h2>Optimize your sponsored articles campaigns</h2>
        </div>

        <div className="homeSectionThree__two--subHeading">
          <p>
            Access an influential media database open to sponsored articles.
            Contact those in your sector and centralize your orders and
            exchanges to save time!
          </p>
        </div>

        <div className="homeSectionThree__two--points">
          <ul>
            <li>
              <img src={Check} />
              Benefit from optimized rates
            </li>
            <li>
              <img src={Check} />
              Filter quickly and easily for your suitable collaboration partners
            </li>
            <li>
              <img src={Check} />
              Brief the media directly according to your expectations
            </li>
            <li>
              <img src={Check} />
              Analyze your performances thanks to a detailed report of your
              articles
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default HomeSectionThree;
